import { t } from '@lingui/macro';
import clsx from 'clsx';

import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import usePanelDataService from '../../../services/PanelDataService';
import PerformanceChart from '../../charts/performance-chart/PerformanceChart';
import { BuiltInTooltip } from '../../charts/tooltip/types';
import { FORMATTER_TYPES } from '../../../utilities/FormattingUtilities';
import { timeRangeFilterId } from '../../filters';

import { useStyles } from './ProcessingTimePanel';

const title = t`Test Results per 5 Minutes`;
const TEST_REULT_NUM_METRIC = 'ngpTestReportNum';

const dataSource = {
    url: '/query/chart',
    params: {
        type: 'ngphealth',
        metrics: [TEST_REULT_NUM_METRIC],
    },
};

const chartConfig = {
    yAxis: [
        {
            title: {
                text: t`Test Results`,
            },
            min: 0,
            allowDecimals: false,
        },
    ],
    tooltip: BuiltInTooltip,
    showGranularity: true,
    chartTrends: [
        {
            formatter: FORMATTER_TYPES.INTEGER,
            units: '',
            chartType: 'spline',
            label: 'Test Results',
            key: TEST_REULT_NUM_METRIC,
            color: '#5DA5DA',
        },
    ],
};
function TestResultNumPanel() {
    const classes = useStyles();
    const data = usePanelDataService(dataSource);
    const chartData = data?.data?.[0];

    if (!data) return null;

    return (
        <div className={clsx('flex-container', classes.chartContainer)}>
            <PerformanceChart
                chartDef={chartConfig}
                data={chartData}
                disableLegend
                xAxis={{ minTickInterval: 5 * 60 * 1000 }}
            />
        </div>
    );
}

TestResultNumPanel.propTypes = panelPropTypes;

TestResultNumPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 175,
    minContentHeight: 175,
};

export default Panel({
    typeAlias: 'nGPTestResultNumTrend',
    filters: {
        required: [timeRangeFilterId],
        optional: [],
    },
})(TestResultNumPanel);
